export const TOAST_DEFAULT_POSITION = 'bottomCenter';
export const TOAST_MAX_COUNT = 6;
